// extracted by mini-css-extract-plugin
export default {"modalBackDrop":"Modal_modalBackDrop__D0zDp","modalContent":"Modal_modalContent__MXCnB"};